import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
    search = '',
    pi = 1,
    ps = 50,
    sort = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.getUserOrgPage, {
        userId,
        search,
        sort,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, pi, ps };
};
